<footer class="pt-10 pb-4 lg:py-[64px] bg-secondary relative z-[99]">
    <div class="container">
        <div class="row gap-y-10 md:mb-10 lg:mb-16 md:order-1">
            <div class="col-6 col-md-4">
                <a routerLink="/" title="Shriram Wealth" class="cursor-pointer">
                    <img [ngSrc]="assetsCDNUrl+'/assets/images/wealth-logo.svg'" alt="Logo" width="120" height="51"
                        class="w-[120px] xxl:w-[160px] md:w-[140px]">
                </a>
                <ul class="hidden md:flex flex-wrap gap-4 mt-4 ">
                    @for (item of socialMedia; track $index) {
                    <li class="cursor-pointer">
                        <a [href]="item.url" [title]="item.title" target="_blank">
                            <img [ngSrc]="assetsCDNUrl+item.imgUrl" [alt]="item.title" width="16" height="16"
                                class="w-5 h-5">
                        </a>
                    </li>
                    }

                </ul>
            </div>
            <div class="col-6 col-md-4 md:order-3 lg:pt-6">
                <p
                    class="text-14 !leading-[18px] mb-4 font-inter-regular text-black md:text-20 xxl:text-30 lg:text-24 md:!leading-[36px]">
                    Stay
                    in touch</p>
                <div class="form-box">
                    <form [formGroup]="touchWithUs" (ngSubmit)="onSubmit()">
                        <div class="relative">
                            <input type="text"
                                class="w-full py-1 pr-5 lg:!pr-8 bg-transparent border-b border-[#7C767640] placeholder:text-12 placeholder:text-black focus:border-[#7C767640] xxl:placeholder:text-16 md:placeholder:text-14 md:text-14 xxl:text-16"
                                placeholder="Enter your email" maxlength="50" input-mask="email"
                                formControlName="email">
                            <button type="submit" title="send"
                                class="bg-transparent min-w-4 min-h-4 lg:min-w-6  bg-[url(/assets/images/icons/right-arrow.svg)] bg-no-repeat bg-center bg-contain absolute right-0 top-2">
                                <span class="sr-only">Enter</span>
                            </button>
                            <app-toast [showToastFailure]="showToastFailure" [toastMsg]="message">
                            </app-toast>
                        </div>

                        @if (touchWithUs.get('email')?.touched && touchWithUs.get('email')?.errors){
                        @if (touchWithUs.get('email')?.hasError('required')){
                        <p class="error !mt-2">Please enter your email</p>
                        }
                        @if (touchWithUs.get('email')?.hasError('pattern')){
                        <p class="error !mt-2">Please enter a valid email</p>
                        }
                        }
                    </form>

                </div>
            </div>
            <div class="col-12 col-md-4 md:order-2">
                <ul class="row gap-y-4 xxl:gap-y-[30px] lg:pt-6">
                    @for (item of linkData; track $index) {
                    <li class="col-6">
                        <a [routerLink]="item.url" [title]="item.title"
                            class="text-14 text-black xxl:text-16  lg:hover:underline"
                            [target]="item.blank ? '_blank' : ''" [innerHTML]="item.name"></a>
                    </li>
                    }
                </ul>
            </div>
        </div>
        <ul class="flex flex-wrap gap-4 justify-end mb-6 mt-3 md:hidden">
            @for (item of socialMedia; track $index) {
            <li class="cursor-pointer">
                <a [href]="item.url" [title]="item.title">
                    <img [ngSrc]="assetsCDNUrl+item.imgUrl" [alt]="item.title" width="16" height="16" class="w-5 h-5">
                </a>
            </li>
            }
        </ul>

        <p class="text-12 mt-4 border-t text-center mb-0 pt-3 md:border-[#1F1F1F40] lg:pt-6 xxl:text-18 lg:leading-5">
            ©2025
            All rights reserved by Shriram Wealth
        </p>
    </div>

</footer>
<app-congratulation-popup [showToastSuccess]="showToastSuccess" [toastMsg]="message">
</app-congratulation-popup>